export function formatDateTime(dateStr?: string, includeTime = true): string {
  if (!dateStr) {
    return "-";
  }
  const date = new Date(dateStr);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const month = date.toLocaleString("en-US", { month: "2-digit" });
  const day = date.toLocaleString("en-US", { day: "2-digit" });
  const year = date.getFullYear();

  let formattedTime = "";
  if (includeTime) {
    formattedTime = new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  }

  let formattedDate: string;
  if (date.toDateString() === today.toDateString()) {
    formattedDate = "Today";
  } else if (date.toDateString() === yesterday.toDateString()) {
    formattedDate = "Yesterday";
  } else {
    formattedDate = `${month}.${day}.${year}`;
  }

  return includeTime ? `${formattedTime} ${formattedDate}` : formattedDate;
}

//TODO: shouldn't be null - I think this isn't caught by typing
//b/c too many "!" are used in YouTubeTranscriptSource
export function formatTimestamp(seconds?: number | null): string {
  if (seconds === undefined || seconds === null) {
    return "-:--";
  }
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  let rv;
  if (hours > 0) {
    rv = `${hours}:${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  } else {
    rv = `${minutes}:${String(remainingSeconds).padStart(2, "0")}`;
  }
  return rv;
}
